import Vue from 'vue'

import App from './App.vue'
import router from './router/router'

//swiper
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
// Vue.use(VueAwesomeSwiper)

// 局部添加Vue-material的组件
import { MdButton, MdContent, MdTabs,MdList } from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import VueMaterial from 'vue-material'
Vue.use(VueMaterial)
Vue.use(MdButton)
Vue.use(MdContent)
Vue.use(MdTabs)
Vue.use(MdList)


//element组件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

//font awesome 字体
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import solid from '@fortawesome/fontawesome-free-solid'
import brands from '@fortawesome/fontawesome-free-brands'
import regular from '@fortawesome/fontawesome-free-regular'
import { library } from '@fortawesome/fontawesome-svg-core'



library.add(solid)
library.add(regular)
library.add(brands)
Vue.component('font-awesome-icon', FontAwesomeIcon)


//axios
import axios from 'axios'
Vue.prototype.$axios = axios
import Moment from 'moment'
Vue.prototype.$moment = Moment
import './utils/momentConfig'


// store
import store from './store'


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
